import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

/**
 * Użycie:
 * <RequireAnyRole roles={['student','admin']}>...</RequireAnyRole>
 */
export default function RequireAnyRole({ roles = [], children }) {
  const { user, isAuthReady } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthReady) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!roles.includes(user.role)) return <Navigate to="/konto" replace />;
  return children;
}
